import TkInfoManual from "../../components/atoms/TkInfoManual";
import "./_style.scss";
import { useContext, useEffect, useState, useRef } from "react";
import { fakeTableList, schema, contextText } from "./parts";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import { Box } from "@mui/material";
import { httpAPI_RET008, httpAPI_RET009, httpAPI_RET013 } from "./api/request";
import { GlobalContext } from "../../context/globalContext";
import { useLocation, useNavigate } from "react-router-dom";
import TkButton from "../../components/atoms/TkButton";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import TkDateDialog from "../../components/molecules/TkDateDialog";
import TkMessageDialog from "../../components/molecules/TkMessageDialog";
import { IAPI_RET009_Request, IAPI_RET013_Response } from "../../type/apiType";
import { labelids } from "../../assets/data/TkExplanationProperty";
import { BusinessContext } from "../../context/businessContext";
import { messageids } from "../../assets/data/TkMessageProperty";
import _ from "lodash";
import { FormClassRetire, FormKbn } from "../../assets/data/Constants";
import { businessCheck } from "./hooks/useHooks";

/**
 * SCRR410028 退職手当金の請求手続き（請求者情報の登録）
 * @return SCRR410028 退職手当金の請求手続き（請求者情報の登録）
 */
const SCRR410028 = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // 認証情報
  const { state, setState } = useContext(GlobalContext);
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);

  const [stateFinancialInfoList, setStateFinancialInfoList] = useState<any>([]);
  const stateFakeTableList = useRef(_.cloneDeep(fakeTableList));
  // 持回情報.申請id
  const applyId = location.state?.applyId;
  // ユーザータイプ
  const userType = state?.authInfo?.userType;
  // ユーザータイプが機構であるか
  const isUserTypeKiko = userType === authorityUserType.userTypeNumber.KIKO;
  // ユーザータイプが退職者ではないか
  const isUserTypeNotTaisyokusya =
    userType !== authorityUserType.userTypeNumber.TAISYOKUSYA;
  // 契約者番号
  const contractorNo = isUserTypeKiko
    ? businessState.common?.contractorNo
    : state.authInfo?.contractorNo;
  // 法人職員番号
  const staffNo = isUserTypeNotTaisyokusya
    ? location.state?.staffNo ?? businessState.job_39?.staffNo
    : state.authInfo?.staffNo;
  const [isOpen, setIsOpen] = useState(false);
  // ワーニングのflag:true表示、false非表示
  const [isOpenWarning, setIsOpenWarning] = useState(false);
  // ダイアログを開くflg
  const [isOpenDialog, setIsOpenDialog] = useState(false);
  // 機構に提出するデータ
  const [submitData, setSubmitData] = useState<IAPI_RET009_Request>({});
  const [res, setRes] = useState<IAPI_RET013_Response>({});

  // 初期表示
  const handleInit = async () => {
    let resArr = stateFakeTableList.current;
    let financialInstitution = resArr.find(
      (item) => item.keyword === "financialInstitution"
    )!;
    financialInstitution.onSuccessfulWithBank = handleRegisterBank;

    /**
     * 持回情報.申請idが設定されている場合
     * 　退職手当金振込先金融機関変更届参照APIを呼び出す
     * 上記以外の場合
     * 　退職手当金の請求手続き（請求者確認）表示APIを呼び出す
     */
    try {
      const res =
        applyId && isUserTypeNotTaisyokusya
          ? await httpAPI_RET008({ contractorNo, applyId })
          : await httpAPI_RET013({ contractorNo, staffNo });

      if (res.resultCd === "I0000") {
        for (let i in res) {
          let targetObj = resArr.find((item) => item.keyword === i)!;

          if (targetObj) {
            targetObj.setDefaultValue = res[i as keyof typeof res];
            if (targetObj.type === "text") {
              targetObj.text = res[i as keyof typeof res];
            }
          }
        }

        // 振込先金融機関
        if (res.aBankCd) {
          resArr.find(
            (i) => i.keyword === "financialInstitution"
          )!.setDefaultValue = {
            bankCode: res.aBankCd,
            bankNameKatakana: res.aBankName,
            branchCode: res.aBranchCd,
            branchNameKatakana: res.aBranchName,
          };
          setSubmitData((prevData) => ({
            ...prevData,
            aBankCd: res.aBankCd,
            aBankName: res.aBankName,
            aBranchCd: res.aBranchCd,
            aBranchName: res.aBranchName,
          }));
        }

        res.applyRelatedList?.forEach((item: any) => {
          let targetObj = resArr.find(
            (i) => i.type === "fileUpload" && i.id === item.formClass
          );

          if (targetObj) {
            targetObj.setDefaultValue = [
              {
                formName: item.fileName ?? item.formName,
                fileBase64: item.fileBase64 ?? item.file,
              },
            ];
          }
        });

        if (applyId && isUserTypeNotTaisyokusya) {
          resArr.forEach((item) => {
            item.disabled = true;
            if (item.keyword === "financialInstitution") {
              item.buttonDisabled = true;
            }
          });
        } else {
          setRes(res as IAPI_RET013_Response);
        }

        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }

      setStateFinancialInfoList([...resArr]);
    } catch {
      navigate("/error");
    }
  };

  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 受領者変更
  const onNavigateChangeRecipient = () => {
    setBusinessState({
      ...businessState,
      job_39: {
        ...businessState.job_39,
        staffNo,
      },
    });

    navigate("/SCRR411119", {
      state: { staffNo, staffName: res.retireStaffName },
    });
  };

  // 申請/機構へ提出
  const onCheckAndSubmit = (data: any) => {
    setSubmitData({
      ...submitData,
      invoiceApplyId: res.retirementApplyId,
      bBankCd: res.bBankCd,
      bBankName: res.bBankName,
      bBranchCd: res.bBranchCd,
      bBranchName: res.bBranchName,
      bAccountHolderKana: res.bAccountHolderKana,
      bDepositType: res.bDepositType,
      bAccountNo: res.bAccountNo,
      aAccountHolderKana: data.aAccountHolderKana,
      aAccountNo: data.aAccountNo,
      applyRelatedForm: [
        {
          serialNo: 1,
          facilityNo: "",
          staffNo: staffNo,
          formKbn: FormKbn["退職書類"],
          formClass: FormClassRetire["振込先金融口座が確認できる書類"],
          fileName: data?.financialAccountConfirmFile?.[0]?.formName,
          file: data?.financialAccountConfirmFile?.[0]?.fileBase64,
        },
        ...(data.nameChangedConfirmFile?.length
          ? [
              {
                serialNo: 2,
                facilityNo: "",
                staffNo: staffNo,
                formKbn: FormKbn["退職書類"],
                formClass:
                  FormClassRetire["氏名が変更されていることを確認できる書類"],
                fileName: data.nameChangedConfirmFile[0].formName,
                file: data.nameChangedConfirmFile[0].fileBase64,
              },
            ]
          : []),
      ],
      screenId: "SCRR410028",
    });

    // 業務チェック
    let checkResult = businessCheck(
      res.bAccountHolderKana!,
      data.aAccountHolderKana,
      data.nameChangedConfirmFile?.length
    );
    let warn = checkResult === "TKMSG_SCR0008W";
    setState({
      ...state,
      errorMsgId: warn ? "" : checkResult,
    });
    if (warn) {
      setIsOpenWarning(true);
      return;
    }
    if (checkResult) return;

    setIsOpen(true);
  };

  const handleUpdate = async (date?: any) => {
    // 退職手当金振込先金融機関変更届更新API 呼び出し
    try {
      const res = await httpAPI_RET009({
        ...submitData,
        receptionDate: date,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });

        navigate("/SCRC070008");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  // 振込先金融機関登録
  const handleRegisterBank = (data: any) => {
    let resArr = stateFakeTableList.current;
    resArr.find((item) => item.keyword === "aBankCd")!.text = data?.bankCode;
    resArr.find((item) => item.keyword === "aBankName")!.text =
      data?.bankNameKatakana;
    resArr.find((item) => item.keyword === "aBranchCd")!.text =
      data?.branchCode;
    resArr.find((item) => item.keyword === "aBranchName")!.text =
      data?.branchNameKatakana;
    setStateFinancialInfoList([...resArr]);
    setSubmitData((prevData) => ({
      ...prevData,
      aBankCd: data?.bankCode,
      aBankName: data?.bankNameKatakana,
      aBranchCd: data?.branchCode,
      aBranchName: data?.branchNameKatakana,
    }));
  };

  return (
    <Box className="SCRR410028" data-testid="SCRR410028PageForTest">
      <TkInfoManual rule={"\\n"}>{labelids.labelid.LBLR410028_01}</TkInfoManual>
      <Box className="changeRecipient">
        <TkButton
          onClick={() => setIsOpenDialog(true)}
          disabled={!!applyId && isUserTypeNotTaisyokusya}
        >
          受領者変更
        </TkButton>
      </Box>
      <TkFakeTable
        list={stateFinancialInfoList}
        ruleSchema={schema}
        onCheckAndSubmit={onCheckAndSubmit}
        submitButtonText={isUserTypeKiko ? "申請" : "機構へ提出する"}
        showButton={!isUserTypeNotTaisyokusya || !applyId}
      />

      {isUserTypeKiko ? (
        <TkDateDialog
          open={isOpen}
          onOky={handleUpdate}
          onCancel={() => setIsOpen(false)}
          minDate={new Date("1900/01/01")}
          maxDate={new Date()}
          title="確認（申請）"
          contextText="申請を行いますが、問題ないでしょうか。"
          cancelText="いいえ"
          okText="はい"
        />
      ) : (
        <TkMessageDialog
          data-testid="TkMessageDialog"
          open={isOpen}
          onOky={handleUpdate}
          onCancel={() => setIsOpen(false)}
          title="確認（機構へ提出する）"
          contextText="機構へ提出を行いますが、問題ないでしょうか。"
          cancelText="いいえ"
          okText="はい"
        />
      )}

      <TkMessageDialog
        data-testid="TkMessageDialogWarning"
        open={isOpenWarning}
        onOky={() => {
          setIsOpen(true);
          setIsOpenWarning(false);
        }}
        onCancel={() => {
          setIsOpenWarning(false);
        }}
        title="警告"
        contextText={`${messageids.messageid["TKMSG_SCR0008W"]}`}
        cancelText="いいえ"
        okText="はい"
      />
      <TkMessageDialog
        open={isOpenDialog}
        onOky={() => {
          onNavigateChangeRecipient();
          setIsOpenDialog(false);
        }}
        onCancel={() => {
          setIsOpenDialog(false);
        }}
        children={<TkInfoManual rule={"\n"}>{contextText}</TkInfoManual>}
        cancelText="いいえ"
        okText="はい"
      />
    </Box>
  );
};

export default SCRR410028;
